import React from "react";
import { TEMAS } from "@/content/site";

// Temas que atravessam a produção — sem ordem obrigatória nem setas de "evolução".
const Temas = ({ light = false }) => (
    <ul data-testid="temas-producao" className={`flex flex-wrap items-center gap-x-1 gap-y-3 font-serif italic ${light ? "text-[#0E2018]" : "text-[#F2EFE5]"}`}>
        {TEMAS.map((t, i) => (
            <li key={t.k} className="flex items-center" title={t.q}>
                <span className="text-[16px] md:text-[19px]">{t.k}</span>
                {i < TEMAS.length - 1 && <span aria-hidden="true" className="mx-3 md:mx-4 not-italic text-[#C7A659]">·</span>}
            </li>
        ))}
    </ul>
);

export default Temas;
